module.exports = __webpack_public_path__ + "static/media/cover.8957e7fe.jpg";